export const CURRENCIES = [
  { code: 'EUR', symbol: '€', el: 'Ευρώ',       en: 'Euro' },
  { code: 'USD', symbol: '$', el: 'Δολάριο',     en: 'US Dollar' },
  { code: 'GBP', symbol: '£', el: 'Λίρα',        en: 'British Pound' },
  { code: 'CHF', symbol: '₣', el: 'Ελβετικό',   en: 'Swiss Franc' },
  { code: 'JPY', symbol: '¥', el: 'Γιεν',        en: 'Japanese Yen' },
  { code: 'CAD', symbol: 'C$', el: 'Καναδικό',  en: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', el: 'Αυστρ.',     en: 'Australian Dollar' },
  { code: 'SEK', symbol: 'kr', el: 'Σουηδική',   en: 'Swedish Krona' },
  { code: 'NOK', symbol: 'kr', el: 'Νορβηγική',  en: 'Norwegian Krone' },
  { code: 'PLN', symbol: 'zł', el: 'Ζλότι',      en: 'Polish Zloty' },
  { code: 'TRY', symbol: '₺', el: 'Λίρα ΤΡ',    en: 'Turkish Lira' },
  { code: 'RON', symbol: 'lei', el: 'Λέι',       en: 'Romanian Leu' },
  { code: 'BGN', symbol: 'лв', el: 'Λεβ',        en: 'Bulgarian Lev' },
  { code: 'CZK', symbol: 'Kč', el: 'Κορώνα',    en: 'Czech Koruna' },
] as const;

export type CurrencyCode = typeof CURRENCIES[number]['code'];

export function currencySymbol(code: string): string {
  return CURRENCIES.find((c) => c.code === code)?.symbol ?? code;
}
